/* eslint-disable import/no-cycle */
/* eslint-disable consistent-return */
import { io } from 'socket.io-client'

import { authenticate } from '../system/auth.service'
import { getConfig } from '../../helpers/system/system.helpers'

const subscribe = (socket, data) => {
  if (!socket) {
    return
  }
  return socket.emit('commands.subscribe', data)
}
const disconnectSocket = (socket) => {
  if (!socket) {
    return
  }
  socket.disconnect()
}

const unsubscribe = (socket, data) => {
  if (!socket) {
    return
  }
  return socket.emit('commands.unsubscribe', data)
}
const connectSocket = async () => {
  const auth = await authenticate()
  if (!auth || !auth.authToken) {
    // ... ouvrir la page login ou msg d'avertissement
    return
  }

  const host = `${getConfig().jimini.socket_base_url}/client`
  if (auth && auth.authToken) {
    return io(host, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5,
      auth: {
        jwttoken: `JWT ${auth.authToken}`,
      },
    })
  }
}
const listeningSocket = (socket, setResponse, setMessage) => {
  let interval = null

  interval = setInterval(() => {
    // -- ping toute les 30 minutes
    socket.emit('ding')
  }, 600000)

  socket.on('commands.data', (data) => {
    setResponse(data)
  })

  socket.on('commands.subscribe.error', () => {
    setMessage({
      text: `commands.subscribe.error `,
      type: 'error',
    })
  })

  socket.on('commands.subscribe.ok', () => {
    setMessage({
      text: `commands.subscribe.ok received`,
      type: 'success',
    })
  })

  socket.on('commands.unsubscribe.error', () => {
    setMessage({
      text: `commands.unsubscribe.error received`,
      type: 'error',
    })
  })
  // -- erreur de connection (évènement socket.io)

  // -- Le client est connecté et authentifié, il peut maintenant s'abonner
  socket.on('connection.ok', (data) => {
    setMessage({
      text: `connect ok ${data}`,
      type: 'success',
    })
  })

  // -- Le client est déconnecté (évènement socket.io)

  // -- Le client est connecté (évènement socket.io)
  socket.on('connect', () => {
    setMessage({
      text: `connect`,
      type: 'success',
    })
  })
  socket.on('reconnect', () => {
    setMessage({
      text: 'reconnect',
      type: 'success',
    })
  })
  socket.on('reconnect_attempt', () => {
    setMessage({
      text: 'reconnect_attempt',
      type: 'error',
    })
  })
  socket.on('reconnect_failed', () => {
    setMessage({
      text: 'reconnect_failed',
      type: 'error',
    })
  })
  socket.on('connect_error', (err) => {
    setMessage({ text: `connect error ${err.message}`, type: 'error' })
    setTimeout(() => {
      socket.connect()
    }, 1000)
  })

  socket.on('disconnect', (reason) => {
    if (reason === 'io server disconnect') {
      // the disconnection was initiated by the server, you need to reconnect manually
      socket.connect()
    }
    clearInterval(interval)
  })
}
export const socketCommandsService = {
  subscribe,
  connectSocket,
  listeningSocket,
  disconnectSocket,
  unsubscribe,
}
